import React, { useContext } from "react";
import { ContentContext } from "../contexts/ContentContext";

export default function TrustedBy() {
    const { data } = useContext(ContentContext);
    const t = data.trustedBy;
    if (!t || !t.items) return null;

    return (
        <section className="py-12 bg-navy-50 border-y border-navy-100">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="text-center text-xs font-bold text-brand-emerald tracking-[0.22em] uppercase mb-6">
                    {t.eyebrow}
                </div>
                <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
                    {t.items.map((name, i) => (
                        <div
                            key={i}
                            className="font-serif text-lg md:text-xl font-bold text-navy-700/70 hover:text-brand-emerald transition"
                        >
                            {name}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
